import React from "react";
import { Grid, Button } from "@mui/material";
import config from '../config.json';
import { BRAND_NAME } from "../../config/constants";

function About() {

  return (
    <div style={{ fontFamily: "Raleway", fontSize: 20, marginLeft: 10 }}>
      <Grid container>
        <Grid item xs={12}>
          <a href="#menu" className="navPanelToggle">
            <span className="fa fa-bars"></span>
          </a>

          <p>
            {BRAND_NAME} is Indias first kiddie time bank for kids that aggregates and amplifies the time put in by a child towards social giving. <br></br>
          </p>
          <p>
            Redefining work to harness latest talent<br></br>
          </p>
        </Grid>
        <p>
          <b>1 million</b> kiddie hours
        </p>
        &nbsp;
        <p>
          across <b>20000</b> kids by <b>2024</b>
        </p>
        <Grid item xs={12}>
          <header>
            <h2>How will we do this?</h2>
          </header>
        </Grid>
        <p>
          {BRAND_NAME} aims to raise awareness in children that social giving can begin with small acts of kindness at home, within communities and encourage them to
          contribute in ways that makes them happy. We encourage students to start their own projects, find projects they are interested to volunteer for, and amplify the
          results of their impacts. Our platform helps track kiddie time across projects to consolidate into one certificate.
          Furthermore, we onboard NGOs and help them by providing kiddie volunteers from {BRAND_NAME}.
        </p>
        <Grid item xs={12}>
          <header>
            <h2>Where are we today?</h2>
          </header>
        </Grid>
        <p>
          Watch our{" "}
          <a
            href={`${process.env.REACT_APP_R2_URL}/socialcred_journey_2024_gjt45m.mp4`}
            target="_blank" rel="noreferrer"
          >
            {" "}2024 Video
          </a>{" "}
          .<br></br>
          1,000,00+ hours across 26 exciting kiddie projects such as Trash Mafia KIDS, PiQture me, Pillow a Young Dreamer, Miyawaki Forest, Covid Orphans, Library, Cred$,
          Friend A Senior, clothes bank, Toy Bank, Notebook program…and lots more launching!
        </p>
        <br></br>
        <br></br>
        <p>
          Join us to build India's largest kiddie time bank!.
        </p>
        <br></br>
        <br></br>
        <Grid item xs={12}>
          <h5
            style={{
              fontSize: 26,
              fontFamily: "Raleway",
            }}
          >
            Clock in your goodwill hours today!
          </h5>
          <Button
            href="/signup/offer"
            style={{
              height: 40,
              fontFamily: "Raleway",
              width: 100,
              backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
              borderRadius: 30,
              color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
            }}
          >
            {" "}
            Sign Up
          </Button>
          &nbsp;&nbsp;&nbsp;
          <Button
            href="/donate"
            style={{
              height: 40,
              fontFamily: "Raleway",
              width: 100,
              backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
              borderRadius: 30,
              color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
            }}
          >
            {" "}
            Donate
          </Button>
        </Grid>
        <Grid item xs={12}>
          <header>
            <h2>Socials</h2>
          </header>
        </Grid>
        <Grid item xs={12}>
          <a href="https://www.instagram.com/giftoftime_/" target="_blank" rel="noreferrer">
            Instagram
          </a>
          <br></br>
          <a href="https://www.facebook.com/" target="_blank" rel="noreferrer">
            Facebook
          </a>
          <br></br>
          <a href="mailto:siyakohli@gmail.com" target="_blank" rel="noreferrer">
            E-mail
          </a>
          <br></br>
          <a href="https://www.linkedin.com/company/gift-of-time-foundation-in/" target="_blank" rel="noreferrer">
            LinkedIn
          </a>
          <br></br>
        </Grid>
        <br></br>
      </Grid>
    </div>
  );
}

export default About;
